import React from 'react';
import './ProgressCard.css';

const ProgressCard = ({ dayCompletion, streak, motivationalMessage, dailyTips }) => {
  const getProgressColor = (percentage) => {
    if (percentage >= 100) return '#10B981'; // Green
    if (percentage >= 75) return '#F59E0B';  // Amber
    if (percentage >= 50) return '#EF4444';  // Red
    return '#6B7280'; // Gray
  };

  const circumference = 2 * Math.PI * 45; // radius = 45
  const strokeDasharray = circumference;
  const strokeDashoffset = circumference - (dayCompletion / 100) * circumference;

  return (
    <div className="progress-card">
      <div className="progress-section">
        <div className="progress-circle-container">
          <svg className="progress-circle" width="100" height="100">
            <circle
              cx="50"
              cy="50"
              r="45"
              stroke="rgba(255, 255, 255, 0.2)"
              strokeWidth="8"
              fill="transparent"
            />
            <circle
              cx="50"
              cy="50"
              r="45"
              stroke={getProgressColor(dayCompletion)}
              strokeWidth="8"
              fill="transparent"
              strokeDasharray={strokeDasharray}
              strokeDashoffset={strokeDashoffset}
              strokeLinecap="round"
              className="progress-circle-fill"
            />
          </svg>
          <div className="progress-text">
            <span className="progress-percentage">{dayCompletion}%</span>
            <span className="progress-label">Complete</span>
          </div>
        </div>
        
        <div className="progress-stats">
          <div className="stat-item">
            <span className="stat-value">{streak}</span>
            <span className="stat-label">Day Streak</span>
          </div>
        </div>
      </div>
      
      <div className="motivation-section">
        <div className="motivation-message">
          <span className="motivation-emoji">{motivationalMessage.emoji}</span>
          <p>{motivationalMessage.message}</p>
        </div>
      </div>
      
      {dailyTips && (
        <div className="tips-section">
          <h4>💡 Today's Tip</h4>
          <p>{dailyTips.tip}</p>
          {dailyTips.keyIngredients && dailyTips.keyIngredients.length > 0 && (
            <div className="key-ingredients">
              <span>Key ingredients for you: </span>
              {dailyTips.keyIngredients.map((ingredient, index) => (
                <span key={ingredient} className="ingredient-tag">
                  {ingredient}
                  {index < dailyTips.keyIngredients.length - 1 && ', '}
                </span>
              ))}
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default ProgressCard;
